import React from 'react';

import { ValidationCampos } from '../../../Validation';
import { InfoPassword } from '../../molecules/InfoPassword';
import { InfoPasswordError } from '../../molecules/InfoPasswordError';

interface ErrorData {
  values?: any;
  errors?: any;
}

export const Errors = ({ values, errors }: ErrorData): JSX.Element => {
  const validationNovaSenha = ValidationCampos(errors);

  return (
    <>
      {values === 'Campo Obrigatório' ? (
        <InfoPasswordError name="Pelo menos 8 caracteres" />
      ) : errors.length < 8 ? (
        <InfoPasswordError name="Pelo menos 8 caracteres" />
      ) : (
        <InfoPassword name="Pelo menos 8 caracteres" />
      )}

      {values === 'Campo Obrigatório' ? (
        <InfoPasswordError name="Contém letra maiúscula (A-Z)" />
      ) : !validationNovaSenha.maiusculas ? (
        <InfoPasswordError name="Contém letra maiúscula (A-Z)" />
      ) : (
        <InfoPassword name="Contém letra maiúscula (A-Z)" />
      )}

      {values === 'Campo Obrigatório' ? (
        <InfoPasswordError name="Contém letra minúscula (a-z)" />
      ) : !validationNovaSenha.minusculas ? (
        <InfoPasswordError name="Contém letra minúscula (a-z)" />
      ) : (
        <InfoPassword name="Contém letra minúscula (a-z)" />
      )}

      {values === 'Campo Obrigatório' ? (
        <InfoPasswordError name="Contém número (0-9)" />
      ) : !validationNovaSenha.numeros ? (
        <InfoPasswordError name="Contém número (0-9)" />
      ) : (
        <InfoPassword name="Contém número (0-9)" />
      )}

      {values === 'Campo Obrigatório' ? (
        <InfoPasswordError name="Contém caractere especial (!@#$&*)" />
      ) : !validationNovaSenha.especialCaracteres ? (
        <InfoPasswordError name="Contém caractere especial (!@#$&*)" />
      ) : (
        <InfoPassword name="Contém caractere especial (!@#$&*)" />
      )}
    </>
  );
};
